// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionList_section__37MHs","sectionText":"SectionList_sectionText__148zU","buttonContainer":"SectionList_buttonContainer__3ApJp","body":"SectionList_body__2n7IN"};